import * as React from "react";

export function UploadCloud(props) {
  return (
      <svg
      width={30}
      height={30}
      viewBox="0 0 30 30"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_333_22)">
        <path d="M13.5413 19.7917V15.625H16.6663L12.4997 10.4167L8.33301 15.625H11.458V19.7917H13.5413Z"
         fill="currentColor"/>
        <path d="M7.29134 19.7917H9.37467V17.7083H7.29134C5.56842 17.7083 4.16634 16.3063 4.16634 14.5833C4.16634 13.1208 5.4153 11.7125 6.95072 11.4427L7.55592 11.3365L7.75593 10.7552C8.48822 8.61876 10.307 7.29168 12.4997 7.29168C15.3716 7.29168 17.708 9.62814 17.708 12.5V13.5417H18.7497C19.8986 13.5417 20.833 14.4761 20.833 15.625C20.833 16.774 19.8986 17.7083 18.7497 17.7083H15.6247V19.7917H18.7497C21.0476 19.7917 22.9163 17.9229 22.9163 15.625C22.9147 14.6913 22.6003 13.785 22.0233 13.0509C21.4463 12.3168 20.6399 11.7972 19.733 11.575C19.2778 7.98959 16.208 5.20834 12.4997 5.20834C9.62884 5.20834 7.13509 6.88647 5.99655 9.53126C3.75905 10.2 2.08301 12.3125 2.08301 14.5833C2.08301 17.4552 4.41947 19.7917 7.29134 19.7917Z" 
        fill="currentColor"/>
      </g>
      <defs>
        <clipPath id="clip0_333_22">
          <path fill="currentColor" d="M0 0H30V30H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
